import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useId } from 'react';
import { useUnsavedChangesStore } from '../stores/useUnsavedChangesStore';

type UseUnsavedChangesOptions = {
  isDirty: boolean;
};

export function useUnsavedChanges({ isDirty }: UseUnsavedChangesOptions) {
  const id = useId();
  const { register, unregister, setDirty } = useUnsavedChangesStore();

  useFocusEffect(
    useCallback(() => {
      register(id);
      return () => {
        unregister(id);
      };
    }, [id, register, unregister]),
  );

  useEffect(() => {
    setDirty(id, isDirty);
  }, [id, isDirty, setDirty]);
}
